import envList from '../../../constants/envList';
import intMax from '../../../assets/img/int_max.jpg';
import intPlus from '../../../assets/img/int_plus.jpg';
import intStandard from '../../../assets/img/int_standard.jpg';
import JobList from './jobList';
import ProductService from '../../../services/ProductService';
import RtMax from '../../../assets/img/Combles_amenages_ChTradi_Suspente_RT_RTmax18_HD_01.jpg';
import RtMaxBicouche from '../../../assets/img/2020_S_CA_ChTradi_SuspenteRT_RTMax18_HD_01.jpg';
import rtMaxImage from '../../../assets/img/rtmax.png';
import rtMaxImageMono from '../../../assets/img/CA_monocouche_pv_RTMAX_Suspente_RT_2020_11.jpg';
import RtPlus from '../../../assets/img/2020_Scene_CA_ChTradi_RTPlus_280_HD_01.png';
import RtPlusBicouche from '../../../assets/img/solution_rtPlus_bicouche.png';
import RtPlusImage from '../../../assets/img/rtplus.png';
import RtPlusImageMono from '../../../assets/img/CA_2022_RT_PLUS_suspente_RT.jpg';
import Standard from '../../../assets/img/Combles_amenages_11_PV_RT_MAX.jpg';
import StandardBicouche from '../../../assets/img/2022_S_CA_ChTradi_RTMax18_SuspAncienModel_HD_02.jpg';
import StandardImage from '../../../assets/img/Combles_amenages_11_pv_RT_MAX_annotee.jpg';
import StandardImageBicouche from '../../../assets/img/CP_2022_chTradi_membraneRTMAX_anciennes_suspensions.jpg';
import CPStandard from '../../../assets/img/2022_S_CP_Tradi_TI212_1couche_HD_01.jpg';
import CPStandardCompo from '../../../assets/img/CP_2022_03_TI212_mono_couche (1).jpg';
import CPRtMaxCompo from '../../../assets/img/CP_2022_03_TI212_bi_couche (1).jpg';
import CPRtMax from '../../../assets/img/2022_S_CP_Tradi_TI212_2couches_HD_01.jpg';
import CPOpti from '../../../assets/img/2021_S_CP_RTMax18_Indus_Supafil_HD_01 (1).jpg';
import CPOptiCompo from '../../../assets/img/Combles_perdus_RT_MAX_soufflage_2021_09.jpg';

/**
 * Generate object with all product information.
 * The need of generating it come from the necessary to have adaptive key.
 * The key correspond to the path of the env, this path can possibily change.
 * If the path change the object change with because it's generate from the envList.
 */
const productInfos = () => {
  const {
    CA: { path: caPath },
    IME: { path: imePath },
    CP: { path: cpPath },
  } = envList;

  return (
    {
      [caPath]: {
        titleKey: 'title_CA',
        compareISO: 'compare_iso_sous_chevrons',
        haveCpt: true,
        haveBicouche: true,
        step: 0.5,
        defaultThermicalResist: 8,
        maxThermicalResist: 10,
        minThermicalResist: 6,
        backgroundStyle: `rgb(255, 123, 0) 0%,
          rgb(253, 235, 74) 5%,
          rgb(201, 247, 0) 25%,
          rgb(179, 255, 0) 50%,
          rgb(97, 233, 7) 75%,
          rgb(11, 167, 45) 100%`,
        thermicalMarks: [
          {
            value: 6,
            pos: '8%',
            titleKey: 'R6',
            className: 'R6CA',
          },
          {
            value: 8,
            pos: '57%',
            titleKey: 'R8',
            className: 'R8',
          },
          {
            value: 10,
            pos: '89%',
            titleKey: 'R10',
            className: 'R10',
          },
        ],
        formula: {
          standard: {
            step: 'standard',
            stepTitle: 'thirdstep',
            percent: false,
            reductionKey: '',
            conformityKey: 'conformity',
            img: Standard,
            bicoucheImg: StandardBicouche,
            id: 'standardHeader',
            titleKey: 'project_standard_title',
            class: 'standardCell',
            tarifMo: 45,
            hourNeeded: 100,
            composantsImg: StandardImage,
            displayTuto: true,
            tutoVideoId: 'qdMXV9NLzzg',
            composantsBicImg: StandardImageBicouche,
            descriptionKey: {
              [JobList.ADMIN]: 'standard_description_user',
              [JobList.USER]: 'standard_description_user',
              [JobList.COMMERCIAL]: 'standard_description_commercial',
              [JobList.PRESCRIBER]: 'standard_description_prescripteur',
              [JobList.BUSINESS]: 'standard_description_entreprise',
              [JobList.PRO]: 'standard_description_pro',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'standard_first_advantage_user',
                'standard_second_advantage_user',
                'standard_third_advantage_user',
              ],
              [JobList.USER]: [
                'standard_first_advantage_user',
                'standard_second_advantage_user',
                'standard_third_advantage_user',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_advantage_commercial',
                'standard_second_advantage_commercial',
                'standard_third_advantage_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_advantage_prescripteur',
                'standard_second_advantage_prescripteur',
                'standard_third_advantage_prescripteur',
                'standard_fourth_advantage_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'standard_first_advantage_entreprise',
                'standard_second_advantage_entreprise',
                'standard_third_advantage_entreprise',
                'standard_fourth_advantage_entreprise',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'standard_first_incovenience_user',
                'standard_second_incovenience_user',
              ],
              [JobList.USER]: [
                'standard_first_incovenience_user',
                'standard_second_incovenience_user',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_incovenience_commercial',
                'standard_second_incovenience_commercial',
                'standard_third_incovenience_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_incovenience_prescripteur',
                'standard_second_incovenience_prescripteur',
                'standard_third_incovenience_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'standard_first_incovenience_entreprise',
                'standard_second_incovenience_entreprise',
                'standard_third_incovenience_entreprise',
                'standard_fourth_incovenience_entreprise',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'standard_iso_entre_chevrons',
                  alwaysShow: false,
                  tableKey: 'standard_table_iso_entre_chevrons',
                  getOptions: (res) => { ProductService.getAllOptions(res); },
                },
                {
                  key: 'standard_iso_sous_chevrons',
                  alwaysShow: true,
                  tableKey: 'standard_table_iso_sous_chevrons',
                  getOptions: (res) => { ProductService.getAllOptions(res); },
                },
                {
                  key: 'standard_suspentes_trad',
                  alwaysShow: true,
                  tableKey: 'standard_table_suspentes_trad',
                  getOptions: (res) => { ProductService.getSuspentesOptions(res); },
                },
                {
                  key: 'standard_membrane',
                  alwaysShow: true,
                  tableKey: 'standard_table_membrane',
                  getOptions: (res) => { ProductService.getMembraneOptions(res); },
                },
                {
                  key: 'standard_adhesif',
                  alwaysShow: true,
                  tableKey: 'standard_table_adhesif',
                  getOptions: (res) => { ProductService.getAdhesifOptions(res); },
                },
                {
                  key: 'standard_solidouble',
                  alwaysShow: false,
                  tableKey: 'standard_table_solidouble',
                  getOptions: () => {},
                },
                {
                  key: 'standard_mastic',
                  alwaysShow: true,
                  tableKey: 'standard_table_mastic',
                  getOptions: (res) => { ProductService.getMasticOptions(res); },
                },
              ],
          },
          rtMax: {
            step: 'rtMax',
            stepTitle: 'fourthstep',
            percent: true,
            reductionKey: 'reductionRtmax',
            conformityKey: 'conformityRtmax',
            img: RtMax,
            bicoucheImg: RtMaxBicouche,
            id: 'rtmaxHeader',
            titleKey: 'project_rtmax_title',
            class: 'rtmaxCell',
            tarifMo: 45,
            hourNeeded: 82,
            displayTuto: true,
            tutoVideoId: 'ZpgWiESmH0M',
            composantsImg: rtMaxImage,
            composantsBicImg: rtMaxImageMono,
            descriptionKey: {
              [JobList.ADMIN]: 'rtmax_description_user',
              [JobList.USER]: 'rtmax_description_user',
              [JobList.COMMERCIAL]: 'rtmax_description_commercial',
              [JobList.PRESCRIBER]: 'rtmax_description_prescripteur',
              [JobList.BUSINESS]: 'rtmax_description_entreprise',
              [JobList.PRO]: 'rtmax_solution_description',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtmax_first_advantage_user',
                'rtmax_second_advantage_user',
                'rtmax_fourth_advantage_user',
                'rtmax_fifth_advantage_user',
              ],
              [JobList.USER]: [
                'rtmax_first_advantage_user',
                'rtmax_second_advantage_user',
                'rtmax_fourth_advantage_user',
                'rtmax_fifth_advantage_user',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_advantage_commercial',
                'rtmax_second_advantage_commercial',
                'rtmax_third_advantage_commercial',
                'rtmax_fourth_advantage_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_advantage_prescripteur',
                'rtmax_second_advantage_prescripteur',
                'rtmax_third_advantage_prescripteur',
                'rtmax_fourth_advantage_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_advantage_entreprise',
                'rtmax_second_advantage_entreprise',
                'rtmax_fourth_advantage_entreprise',
                'rtmax_fifth_advantage_entreprise',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtmax_first_incovenience_user',
              ],
              [JobList.USER]: [
                'rtmax_first_incovenience_user',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_incovenience_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_incovenience_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_incovenience_entreprise',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'rtmax_iso_entre_chevrons',
                  alwaysShow: false,
                },
                {
                  key: 'rtmax_iso_sous_chevrons',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_suspentes',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_membrane',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_adhesif',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_mastic',
                  alwaysShow: true,
                },
              ],
          },
          rtPlus: {
            step: 'rtPlus',
            stepTitle: 'fifthstep',
            percent: true,
            reductionKey: 'reductionRtPlus',
            conformityKey: 'conformityRtplus',
            img: RtPlus,
            bicoucheImg: RtPlusBicouche,
            id: 'rtplusHeader',
            titleKey: 'project_rtplus_title',
            class: 'rtplusCell',
            tarifMo: 45,
            hourNeeded: 74,
            displayTuto: true,
            tutoVideoId: '2Qu-uFW1kGs',
            composantsImg: RtPlusImage,
            composantsBicImg: RtPlusImageMono,
            descriptionKey: {
              [JobList.ADMIN]: 'rtplus_description_user',
              [JobList.USER]: 'rtplus_description_user',
              [JobList.COMMERCIAL]: 'rtplus_description_commercial',
              [JobList.PRESCRIBER]: 'rtplus_description_prescripteur',
              [JobList.BUSINESS]: 'rtplus_description_entreprise',
              [JobList.PRO]: 'rtplus_solution_description',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtplus_first_advantage_user',
                'rtplus_second_advantage_user',
                'rtplus_third_advantage_user',
                'rtplus_fourth_advantage_user',
                'rtplus_fifth_advantage_user',
              ],
              [JobList.USER]: [
                'rtplus_first_advantage_user',
                'rtplus_second_advantage_user',
                'rtplus_third_advantage_user',
                'rtplus_fourth_advantage_user',
                'rtplus_fifth_advantage_user',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_advantage_commercial',
                'rtplus_second_advantage_commercial',
                'rtplus_third_advantage_commercial',
                'rtplus_fourth_advantage_commercial',
                'rtplus_fifth_advantage_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_advantage_prescripteur',
                'rtplus_second_advantage_prescripteur',
                'rtplus_third_advantage_prescripteur',
                'rtplus_fourth_advantage_prescripteur',
                'rtplus_fifth_advantage_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_advantage_entreprise',
                'rtplus_second_advantage_entreprise',
                'rtplus_third_advantage_entreprise',
                'rtplus_fourth_advantage_entreprise',
                'rtplus_fifth_advantage_entreprise',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtplus_first_benefit_user',
              ],
              [JobList.USER]: [
                'rtplus_first_benefit_user',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_benefit_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_benefit_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_benefit_entreprise',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'rtplus_iso_entre_chevrons',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_iso_sous_chevrons',
                  alwaysShow: false,
                },
                {
                  key: 'rtplus_suspentes',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_manchons',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_adhesif',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_mastic',
                  alwaysShow: true,
                },
              ],
          },
        },
      },
      [imePath]: {
        titleKey: 'title_IME',
        compareISO: 'compare_mur_ext_iso',
        haveCpt: false,
        haveBicouche: false,
        step: 0.5,
        defaultThermicalResist: 6,
        maxThermicalResist: 6,
        minThermicalResist: 2,
        backgroundStyle: `rgb(227, 36, 20) 0%,
          rgb(253, 235, 74) 35%,
          rgb(253, 235, 74) 45%,
          rgb(97, 233, 7) 100%`,
        thermicalMarks: [
          {
            value: 3,
            pos: '51%',
            titleKey: 'R3',
            className: 'R3',
          },
          {
            value: 4,
            pos: '51%',
            titleKey: 'R4',
            className: 'R4',
          },
          {
            value: 5,
            pos: '79%',
            titleKey: 'R5',
            className: 'R5IME',
          },
          {
            value: 6,
            pos: '99%',
            titleKey: 'R6',
            className: 'R6IME',
          },
        ],
        formula: {
          standard: {
            step: 'standard',
            stepTitle: 'thirdstep',
            percent: false,
            reductionKey: '',
            img: intStandard,
            id: 'standardHeader',
            titleKey: 'project_standard_title',
            class: 'standardCell',
            tarifMo: 45,
            hourNeeded: 62,
            displayTuto: false,
            tutoVideoId: '',
            composantsImg: intStandard,
            descriptionKey: {
              [JobList.ADMIN]: 'standard_description_user_IME',
              [JobList.USER]: 'standard_description_user_IME',
              [JobList.COMMERCIAL]: 'standard_description_entreprise_IME',
              [JobList.PRESCRIBER]: 'standard_description_prescripteur_IME',
              [JobList.BUSINESS]: 'standard_description_commercial_IME',
              [JobList.PRO]: 'standard_description_pro_IME',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'standard_first_advantage_user_IME',
                'standard_second_advantage_user_IME',
                'standard_third_advantage_user_IME',
              ],
              [JobList.USER]: [
                'standard_first_advantage_user_IME',
                'standard_second_advantage_user_IME',
                'standard_third_advantage_user_IME',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_advantage_commercial_IME',
                'standard_second_advantage_commercial_IME',
                'standard_third_advantage_commercial_IME',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_advantage_prescripteur_IME',
                'standard_second_advantage_prescripteur_IME',
                'standard_third_advantage_prescripteur_IME',
              ],
              [JobList.BUSINESS]: [
                'standard_first_advantage_entreprise_IME',
                'standard_second_advantage_entreprise_IME',
                'standard_third_advantage_entreprise_IME',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'standard_first_incovenience_user',
                'standard_second_incovenience_user',
              ],
              [JobList.USER]: [
                'standard_first_incovenience_user',
                'standard_second_incovenience_user',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_incovenience_commercial',
                'standard_second_incovenience_commercial',
                'standard_third_incovenience_commercial',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_incovenience_prescripteur',
                'standard_second_incovenience_prescripteur',
                'standard_third_incovenience_prescripteur',
              ],
              [JobList.BUSINESS]: [
                'standard_first_incovenience_entreprise',
                'standard_second_incovenience_entreprise',
                'standard_third_incovenience_entreprise',
                'standard_fourth_incovenience_entreprise',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'IME_component_1',
                  alwaysShow: true,
                },
                {
                  key: 'IME_component_2',
                  alwaysShow: true,
                },
                {
                  key: 'IME_component_3',
                  alwaysShow: true,
                },
              ],
          },
          rtMax: {
            step: 'rtMax',
            stepTitle: 'fourthstep',
            percent: true,
            img: intMax,
            reductionKey: 'reductionRtmax',
            id: 'rtmaxHeader',
            titleKey: 'project_rtmax_title',
            class: 'rtmaxCell',
            tarifMo: 45,
            hourNeeded: 81,
            displayTuto: false,
            tutoVideoId: 'L-ZBRyeX-0g',
            composantsImg: intMax,
            composantsBicImg: intMax,
            descriptionKey: {
              [JobList.ADMIN]: 'rtmax_description_user_IME',
              [JobList.USER]: 'rtmax_description_user_IME',
              [JobList.COMMERCIAL]: 'rtmax_description_entreprise_IME',
              [JobList.PRESCRIBER]: 'rtmax_description_prescripteur_IME',
              [JobList.BUSINESS]: 'rtmax_description_commercial_IME',
              [JobList.PRO]: 'rtmax_solution_description_IME',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtmax_first_advantage_user_IME',
                'rtmax_second_advantage_user_IME',
                'rtmax_third_advantage_user_IME',
                'rtmax_fourth_advantage_user_IME',
                'rtmax_fifth_advantage_user_IME',
              ],
              [JobList.USER]: [
                'rtmax_first_advantage_user_IME',
                'rtmax_second_advantage_user_IME',
                'rtmax_third_advantage_user_IME',
                'rtmax_fourth_advantage_user_IME',
                'rtmax_fifth_advantage_user_IME',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_advantage_commercial_IME',
                'rtmax_second_advantage_commercial_IME',
                'rtmax_third_advantage_commercial_IME',
                'rtmax_fourth_advantage_commercial_IME',
                'rtmax_fifth_advantage_commercial_IME',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_advantage_prescripteur_IME',
                'rtmax_second_advantage_prescripteur_IME',
                'rtmax_third_advantage_prescripteur_IME',
                'rtmax_fourth_advantage_prescripteur_IME',
                'rtmax_fifth_advantage_prescripteur_IME',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_advantage_entreprise_IME',
                'rtmax_second_advantage_entreprise_IME',
                'rtmax_third_advantage_entreprise_IME',
                'rtmax_fourth_advantage_entreprise_IME',
                'rtmax_fifth_advantage_entreprise_IME',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtmax_first_incovenience_user_IME',
              ],
              [JobList.USER]: [
                'rtmax_first_incovenience_user_IME',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_incovenience_commercial_IME',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_incovenience_prescripteur_IME',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_incovenience_entreprise_IME',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'rtmax_insulation',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_support',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_membrane_IME',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_pastille',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_adhesif_IME',
                  alwaysShow: true,
                },
                {
                  key: 'rtmax_mastic_IME',
                  alwaysShow: true,
                },
              ],
          },
          rtPlus: {
            step: 'rtPlus',
            stepTitle: 'fifthstep',
            composantsBicImg: intPlus,
            percent: true,
            reductionKey: 'reductionRtPlus',
            img: intPlus,
            id: 'rtplusHeader',
            titleKey: 'project_rtplus_title',
            class: 'rtplusCell',
            tarifMo: 45,
            hourNeeded: 69,
            displayTuto: true,
            tutoVideoId: 'Vjhg6LDUItw',
            composantsImg: intPlus,
            descriptionKey: {
              [JobList.ADMIN]: 'rtplus_description_user_IME',
              [JobList.USER]: 'rtplus_description_user_IME',
              [JobList.COMMERCIAL]: 'rtplus_description_entreprise_IME',
              [JobList.PRESCRIBER]: 'rtplus_description_prescripteur_IME',
              [JobList.BUSINESS]: 'rtplus_description_commercial_IME',
              [JobList.PRO]: 'rtplus_solution_description_IME',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtplus_first_advantage_user_IME',
                'rtplus_second_advantage_user_IME',
                'rtplus_third_advantage_user_IME',
                'rtplus_fourth_advantage_user_IME',
                'rtplus_fifth_advantage_user_IME',
                'rtplus_sixth_advantage_user_IME',
                'rtplus_seventh_advantage_user_IME',
              ],
              [JobList.USER]: [
                'rtplus_first_advantage_user_IME',
                'rtplus_second_advantage_user_IME',
                'rtplus_third_advantage_user_IME',
                'rtplus_fourth_advantage_user_IME',
                'rtplus_fifth_advantage_user_IME',
                'rtplus_sixth_advantage_user_IME',
                'rtplus_seventh_advantage_user_IME',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_advantage_commercial_IME',
                'rtplus_second_advantage_commercial_IME',
                'rtplus_third_advantage_commercial_IME',
                'rtplus_fourth_advantage_commercial_IME',
                'rtplus_fifth_advantage_commercial_IME',
                'rtplus_sixth_advantage_commercial_IME',
                'rtplus_seventh_advantage_commercial_IME',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_advantage_prescripteur_IME',
                'rtplus_second_advantage_prescripteur_IME',
                'rtplus_third_advantage_prescripteur_IME',
                'rtplus_fourth_advantage_prescripteur_IME',
                'rtplus_fifth_advantage_prescripteur_IME',
                'rtplus_sixth_advantage_prescripteur_IME',
                'rtplus_seventh_advantage_prescripteur_IME',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_advantage_entreprise_IME',
                'rtplus_second_advantage_entreprise_IME',
                'rtplus_third_advantage_entreprise_IME',
                'rtplus_fourth_advantage_entreprise_IME',
                'rtplus_fifth_advantage_entreprise_IME',
                'rtplus_sixth_advantage_entreprise_IME',
                'rtplus_seventh_advantage_entreprise_IME',
              ],
              [JobList.PRO]: [],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtplus_first_benefit_user_IME',
              ],
              [JobList.USER]: [
                'rtplus_first_benefit_user_IME',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_benefit_commercial_IME',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_benefit_prescripteur_IME',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_benefit_entreprise_IME',
              ],
              [JobList.PRO]: [],
            },
            components:
              [
                {
                  key: 'rtplus_insulate_IME',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_support_IME',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_pastille',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_adhesif_IME',
                  alwaysShow: true,
                },
                {
                  key: 'rtplus_mastic_IME',
                  alwaysShow: true,
                },
              ],
          },
        },
      },
      [cpPath]: {
        titleKey: 'title_CP',
        haveCpt: true,
        step: 1,
        defaultThermicalResist: 5,
        maxThermicalResist: 12,
        minThermicalResist: 5,
        backgroundStyle: `rgb(227, 36, 20) 0%,
          rgb(253, 235, 74) 21%,
          rgb(253, 235, 74) 34%,
          rgb(97, 233, 7) 100%`,
        thermicalMarks: [
          {
            value: 6,
            pos: '8%',
            titleKey: 'R6',
            className: 'R6CP',
          },
          {
            value: 8,
            pos: '57%',
            titleKey: 'R8',
            className: 'R8CP',
          },
          {
            value: 10,
            pos: '89%',
            titleKey: 'R10',
            className: 'R10CP',
          },
        ],
        formula: {
          standard: {
            step: 'standard',
            stepTitle: 'thirdstep',
            asterisk: true,
            percent: false,
            reductionKey: '',
            conformityKey: 'conformityCP',
            img: CPStandard,
            id: 'standardHeader',
            titleKey: 'project_standard_title',
            class: 'standardCell',
            tarifMo: 45,
            hourNeeded: 10,
            composantsImg: CPStandardCompo,
            displayTuto: false,
            tutoVideoId: '',
            next: 'rtMax',
            descriptionKey: {
              [JobList.ADMIN]: 'standard_description_user_CP',
              [JobList.USER]: 'standard_description_user_CP',
              [JobList.COMMERCIAL]: 'standard_description_user_CP',
              [JobList.PRESCRIBER]: 'standard_description_user_CP',
              [JobList.BUSINESS]: 'standard_description_user_CP',
              [JobList.PRO]: 'standard_description_user_CP',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
              [JobList.USER]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
              [JobList.BUSINESS]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
              [JobList.PRO]: [
                'standard_first_advantage_CP',
                'standard_second_advantage_CP',
                'standard_third_advantage_CP',
                'standard_fourth_advantage_CP',
                'standard_fifth_advantage_CP',
              ],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
              [JobList.USER]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
              [JobList.COMMERCIAL]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
              [JobList.PRESCRIBER]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
              [JobList.BUSINESS]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
              [JobList.PRO]: [
                'standard_first_incovenience_user_CP',
                'standard_second_incovenience_user_CP',
                'standard_third_incovenience_user_CP',
              ],
            },
            components:
              [
                {
                  key: 'standard_iso_entre_solive',
                  alwaysShow: true,
                },
                {
                  key: 'CP_component_4',
                  alwaysShow: true,
                },
                {
                  key: 'CP_component_5',
                  alwaysShow: true,
                },
                {
                  key: 'CP_component_6',
                  alwaysShow: true,
                },
              ],
          },
          rtMax: {
            step: 'rtMax',
            stepTitle: 'fourthstep',
            percent: true,
            reductionKey: 'reductionRtmax',
            conformityKey: 'conformityRtMaxCP',
            img: CPRtMax,
            id: 'rtmaxHeader',
            titleKey: 'project_rtmax_title',
            class: 'rtmaxCell',
            tarifMo: 45,
            asterisk: true,
            hourNeeded: 6,
            displayTuto: false,
            next: 'rtPlus',
            composantsBicImg: CPRtMaxCompo,
            descriptionKey: {
              [JobList.ADMIN]: 'rtmax_description_user_CP',
              [JobList.USER]: 'rtmax_description_user_CP',
              [JobList.COMMERCIAL]: 'rtmax_description_user_CP',
              [JobList.PRESCRIBER]: 'rtmax_description_user_CP',
              [JobList.BUSINESS]: 'rtmax_description_user_CP',
              [JobList.PRO]: 'rtmax_description_user_CP',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
              [JobList.USER]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
              [JobList.PRO]: [
                'rtmax_first_advantage_user_CP',
                'rtmax_second_advantage_user_CP',
                'rtmax_third_advantage_user_CP',
                'rtmax_fourth_advantage_user_CP',
              ],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
              [JobList.USER]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
              [JobList.COMMERCIAL]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
              [JobList.PRESCRIBER]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
              [JobList.BUSINESS]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
              [JobList.PRO]: [
                'rtmax_first_incovenience_user_CP',
                'rtmax_second_incovenience_user_CP',
                'rtmax_third_incovenience_user_CP',
              ],
            },
            components:
              [
                {
                  key: 'CP_component_1',
                  alwaysShow: true,
                  componentKey: 'selectedInsulator',
                  hasList: true,
                  enableList: false,
                  listKey: 'insulators',
                  usedKey: 'usedInsBet',
                  usedLabel: 'meter_square',
                  nbKey: 'nbRollInsBet',
                  nbLabel: 'rolls',
                  priceLabel: 'euroMeter',
                  costKey: 'costInsBet',
                  costLabel: 'euroMeter',
                },
                {
                  key: 'CP_component_2',
                  alwaysShow: true,
                  componentKey: 'selectedInsulatorSecond',
                  hasList: true,
                  listKey: 'insulatorsSecond',
                  usedKey: 'usedSec',
                  usedLabel: 'meter_square',
                  nbKey: 'nbRollSec',
                  nbLabel: 'rolls',
                  priceLabel: 'euroKilo',
                  costKey: 'costSec',
                  costLabel: 'euroKilo',
                },
                {
                  key: 'CP_component_3',
                  alwaysShow: true,
                  componentKey: 'selectedMembrane',
                  hasList: true,
                  enableList: true,
                  listKey: 'membranes',
                  usedKey: 'usedMem',
                  usedLabel: 'meter_square',
                  nbKey: 'nbRollMem',
                  nbLabel: 'rolls',
                  priceLabel: 'euroRoll',
                  costKey: 'costMem',
                  costLabel: 'euroRoll',
                },
                {
                  key: 'CP_component_4',
                  alwaysShow: true,
                  componentKey: 'selectedAdhesive',
                  hasList: false,
                  enableList: false,
                  listKey: 'adhesives',
                  usedKey: 'usedAdhesif',
                  usedLabel: 'ml',
                  nbKey: 'adhesifBox',
                  nbLabel: 'rolls',
                  priceLabel: 'rtmax_table_insulation_unit_price',
                  costKey: 'adhesifCost',
                  costLabel: 'rtmax_table_insulation_unit_price',
                },
                {
                  key: 'CP_component_5',
                  alwaysShow: true,
                  componentKey: 'selectedMastic',
                  hasList: false,
                  listKey: 'mastics',
                  usedKey: 'usedMastic',
                  usedLabel: 'ml',
                  nbKey: 'masticBox',
                  nbLabel: 'cartridges',
                  priceLabel: 'euroCartridges',
                  costKey: 'masticCost',
                  costLabel: 'euroCartridges',
                },
              ],
          },
          rtPlus: {
            step: 'rtPlus',
            stepTitle: 'fifthstep',
            percent: true,
            reductionKey: 'reductionRtPlus',
            conformityKey: 'conformutyRtPlusCP',
            img: CPOpti,
            id: 'rtplusHeader',
            titleKey: 'project_rtplus_title',
            class: 'rtplusCell',
            tarifMo: 45,
            hourNeeded: 6,
            displayTuto: false,
            composantsBicImg: CPOptiCompo,
            descriptionKey: {
              [JobList.ADMIN]: 'rtplus_description_user_CP',
              [JobList.USER]: 'rtplus_description_user_CP',
              [JobList.COMMERCIAL]: 'rtplus_description_user_CP',
              [JobList.PRESCRIBER]: 'rtplus_description_user_CP',
              [JobList.BUSINESS]: 'rtplus_description_user_CP',
              [JobList.PRO]: 'rtplus_description_user_CP',
            },
            advantageKey: {
              [JobList.ADMIN]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
              [JobList.USER]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
              [JobList.PRO]: [
                'rtplus_first_advantage_user_CP',
                'rtplus_second_advantage_user_CP',
                'rtplus_third_advantage_user_CP',
                'rtplus_fourth_advantage_user_CP',
              ],
            },
            inconvenienceKey: {
              [JobList.ADMIN]: [
                'rtplus_first_benefit_user_CP',
              ],
              [JobList.USER]: [
                'rtplus_first_benefit_user_CP',
              ],
              [JobList.COMMERCIAL]: [
                'rtplus_first_benefit_user_CP',
              ],
              [JobList.PRESCRIBER]: [
                'rtplus_first_benefit_user_CP',
              ],
              [JobList.BUSINESS]: [
                'rtplus_first_benefit_user_CP',
              ],
              [JobList.PRO]: [
                'rtplus_first_benefit_user_CP',
              ],
            },
            components:
              [
                {
                  key: 'CP_component_1',
                  alwaysShow: true,
                  componentKey: 'selectedInsulator',
                  hasList: true,
                  listKey: 'insulators',
                  usedKey: 'usedInsBlown',
                  usedLabel: 'mm',
                  nbKey: 'nbRollInsBlown',
                  nbLabel: 'kg',
                  priceLabel: 'euroKilo',
                  costKey: 'costInsBlown',
                  costLabel: 'euroKilo',
                },
                {
                  key: 'CP_component_2',
                  alwaysShow: true,
                  componentKey: 'selectedSuspentes',
                  hasList: true,
                  listKey: 'shroud',
                  usedKey: 'qteUsed',
                  usedLabel: 'rtmax_table_support_surfaces',
                  nbKey: 'nbBox',
                  nbLabel: 'rtmax_table_support_content_type',
                  priceLabel: 'euroKilo',
                  costKey: 'tarifDeSurface',
                  costLabel: 'euroKilo',
                },
                {
                  key: 'CP_component_3',
                  alwaysShow: true,
                  componentKey: 'selectedAdhesive',
                  hasList: false,
                  listKey: 'adhesives',
                  usedKey: 'usedAdhesif',
                  usedLabel: 'ml',
                  nbKey: 'adhesifBox',
                  nbLabel: 'rolls',
                  priceLabel: 'euroRoll',
                  costKey: 'adhesifCost',
                  costLabel: 'euroRoll',
                },
                {
                  key: 'CP_component_4',
                  alwaysShow: true,
                  componentKey: 'selectedMembrane',
                  hasList: true,
                  enableList: true,
                  listKey: 'membranes',
                  usedKey: 'usedMem',
                  usedLabel: 'meter_square',
                  nbKey: 'nbRollMem',
                  nbLabel: 'rolls',
                  priceLabel: 'rtmax_table_insulation_unit_price',
                  costKey: 'costMem',
                  costLabel: 'rtmax_table_insulation_unit_price',
                },
                {
                  key: 'rtplus_mastic',
                  alwaysShow: true,
                  componentKey: 'selectedMastic',
                  hasList: false,
                  listKey: 'mastics',
                  usedKey: 'usedMastic',
                  usedLabel: 'ml',
                  nbKey: 'masticBox',
                  nbLabel: 'cartridges',
                  priceLabel: 'euroCartridges',
                  costKey: 'masticCost',
                  costLabel: 'euroCartridges',
                },
              ],
          },
        },
      },
    }
  );
};

export default productInfos();



// WEBPACK FOOTER //
// ./src/components/Protected/projet/productInfos.js